import React, { useEffect, useReducer, useState} from 'react';
import {Container, Row,Button, Nav, Accordion} from 'react-bootstrap'
import { Link } from 'react-router-dom';
import Footer from './Footer';
import Header from './Header';
import $ from "jquery"

import "../stylesheets/style.css"
import "../stylesheets/webapp.css"
import "../js/main.js"
import Testimonials from './Testimonials';
import Faq from './Faq';
import Contact from './Contact'

const Signin = () => {

  const [Notify, SetNotify] = useState("")
    useEffect(() =>{
        document.title = "Sign In | Earth VIII Apartments"
    },[])


    const signUserIn = () =>{  
      var settingstwo = {
      beforeSend: function(){
          SetNotify("Processing...")
      },
      "url": "https://earthvii-api.herokuapp.com/v1/registration/sign_in/",
      "method": "POST",
      "timeout": 0,
      //  "headers": { "X-ApiKey": "SfeILETE0TcCFOziCtTXBPxfqsmTR6aO5F+3cJRmobMf/w8HEVw7xqAvAyNPlD0O"},
       "data":
       {
          
           "email":document.getElementById("email").value, 
           "password":document.getElementById("password").value, 
        
       },
       error: function(xhr, status, error) {
         console.log(xhr.status)
        if(xhr.status==404) {
          console.log(xhr.responseJSON)
          SetNotify("**Missing Field (s)")
          // alert(thrownError);
      }

      else if(xhr.status==401) {
        console.log(xhr.responseJSON)
        SetNotify("Please confirm your e-mail.")
        // alert(thrownError);
    }

    else if(xhr.status==400) {
      console.log(xhr.responseJSON)
      SetNotify("**Missing Fields")
      // alert(thrownError);
  }
          
  },
       complete: function(){
      
      }
      }
           
      $.ajax(settingstwo).done(function (responsetwo) {
        console.log(responsetwo)
        localStorage.setItem("userpin", responsetwo.pin_confirmation_url );
        localStorage.setItem("accesstoken", responsetwo.tokens.access );

          SetNotify("Redirecting...")
          window.location.replace("/home");
 
      })
  
  } 

    return (
      
      <div>
<div>
<Header/>
<div className='signinbody'>
<div className="row">

<div class="col-md-6">

</div>

<div class="col-md-4 signinformbox">
  <h2 className='signinhead'>Welcome back</h2>
  <p className='signinsubtitle'>Input your details to log in</p>
  {/* <p className='signinsubtitle formobileonly'>For you to create an account, kindly fill in your information in the form below.</p> */}



<div className="row">
<div className='col-md-2'>
  
</div>

<div className='col-md-8'>
<div className=''>


  <div class="form-group mobilesigninforngroup">
    <label className='signinlabel2' for="">Email Address</label>
    <input type="email" class="form-control form-control-lg hminput" id="email" placeholder="E-mail Address"/>
  </div>


  <div class="form-group mobilesigninforngroup">
    <label className='signinlabel2' for="">Password</label>
    <input type="password" class="form-control form-control-lg hminput" id="password" placeholder="Password"/>
  </div>

</div>
<p>{Notify}</p>
<div className="d-grid">
<button onClick={signUserIn} class="signinbutton">Sign in</button>

</div>
<p>
<Nav.Link className="signinalready singninoptions mobilesigninforngroup" as={Link} to="/signup" eventKey="3" activeClassName="is-active" >New user ? Sign up here </Nav.Link>
  <Nav.Link className="signinalready singninoptions fpassword" as={Link} to="/recoverpassword" eventKey="3" activeClassName="is-active" >Forgot password?</Nav.Link>

</p>


</div>

<div className='col-md-2'>
  
</div>
</div>



</div>
</div>
  </div>

</div>


<br/>
<br/>
<br/>



    {/* <Footer/> */}
    </div>


    )
    
    
}


export {Signin as default}